import { render, staticRenderFns } from "./PreventFolderArchiveDialog.vue?vue&type=template&id=9269289e&scoped=true&"
import script from "./PreventFolderArchiveDialog.vue?vue&type=script&lang=js&"
export * from "./PreventFolderArchiveDialog.vue?vue&type=script&lang=js&"
import style0 from "./PreventFolderArchiveDialog.vue?vue&type=style&index=0&id=9269289e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9269289e",
  null
  
)

export default component.exports